export default {
  tooltip: {
    trigger: 'axis',
    formatter: (params) => {
      let str = ''
      params.forEach((item, index) => {
        const temp = {}
        if (item.seriesName === '媒体消耗' || item.seriesName === '媒体成交eCPM') {
          temp.value = '￥' + item.value
        } else if (
          item.seriesName === '流量填充率' ||
          item.seriesName === '广告填充率' ||
          item.seriesName === '点击率' ||
          item.seriesName === '请求填充率'
        ) {
          temp.value = item.value + '%'
        } else {
          temp.value = item.value
        }
        str += item.marker + item.seriesName + ': ' + temp.value + '<br>'
      })

      return params[0].axisValue + '<br>' + str
    }
  },
  legend: {
    show: true
  },
  grid: {
    left: '3%',
    right: '3%',
    bottom: '3%',
    containLabel: true
  },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    data: [],
    axisLine: {
      lineStyle: {
        color: '#000',
        width: 0.5
      }
    }
  },
  yAxis: [
    // 0
    {
      type: 'value',
      position: 'left',
      axisLine: {
        lineStyle: {
          color: '#000',
          width: 0.5
        }
      },
      splitLine: {
        show: true
      },

      axisTick: {
        show: true
      },

      axisLabel: {
        show: true
      }
    }
  ],
  series: []
}
